export const performanceSummarySelector = (period: string) => (state: any) => state.performanceSummary.data; 